module.exports = __webpack_public_path__ + "static/media/cal.08db4c88.svg";